import React from 'react';

const AUTOMACOES = [
  {
    id: 1,
    nome: 'Notificação de Nova Oportunidade',
    descricao: 'Quando uma SDR cria uma nova oportunidade, o grupo do WhatsApp é notificado automaticamente em tempo real.',
    gatilho: 'Tempo real — ao criar oportunidade',
    canal: 'WhatsApp Grupo',
    ativo: true,
    detalhes: [
      'Disparada apenas quando o criador tem cargo SDR',
      'Mensagem enviada para o grupo de oportunidades',
    ],
  },
  {
    id: 4,
    nome: 'Apresentação do Closer ao Contato',
    descricao: 'Ao criar uma oportunidade, o WhatsApp do Closer responsável envia automaticamente uma mensagem de apresentação para o contato.',
    gatilho: 'Tempo real — 10 segundos após criar oportunidade',
    canal: 'WhatsApp Pessoal — Closer responsável',
    ativo: true,
    detalhes: [
      'Disparada apenas quando o criador tem cargo SDR',
      'Mensagem enviada pelo WhatsApp do Closer indicado',
      'Cita o nome do Closer e da SDR na mensagem',
      'Exige telefone preenchido na oportunidade',
    ],
  },
  {
    id: 2,
    nome: 'Resumo Diário de Oportunidades',
    descricao: 'Todo dia às 18:10h um resumo com todas as oportunidades criadas no dia é enviado para o WhatsApp do Vagner.',
    gatilho: 'Todo dia às 18:10h (BRT)',
    canal: 'WhatsApp Pessoal — Vagner',
    ativo: true,
    detalhes: [
      'Lista todas as oportunidades criadas no dia',
      'Informa SDR, Closer e etapa de cada uma',
    ],
  },
  {
    id: 3,
    nome: 'Aquecimento de Leads Sem Interação',
    descricao: 'Toda sexta-feira às 10h, mensagens automáticas são enviadas para contatos em "Sem Interação", a partir do WhatsApp do closer responsável.',
    gatilho: 'Toda sexta-feira às 10h (BRT)',
    canal: 'WhatsApp Pessoal — Closer responsável',
    ativo: true,
    detalhes: [
      'Máximo de 3 contatos por oportunidade',
      '1º contato: primeiro envio',
      '2º contato: 15 dias após o 1º',
      '3º contato: 60 dias após o 1º',
      'Após 3 contatos, a oportunidade não recebe mais mensagens',
    ],
  },
];

export default function Automacoes() {
  return (
    <div style={{ maxWidth: 760 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
        <div>
          <h1 style={{ fontSize: 17, fontWeight: 700, color: '#0a1628' }}>Automações</h1>
          <p style={{ color: '#6b7280', fontSize: 12, marginTop: 1 }}>Processos automáticos ativos no sistema</p>
        </div>
        <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 4, padding: '3px 10px', fontSize: 12, fontWeight: 600, color: '#16a34a' }}>
          {AUTOMACOES.filter(a => a.ativo).length} ativas
        </div>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {AUTOMACOES.map(a => (
          <div key={a.id} style={{ background: '#fff', borderRadius: 4, border: '1px solid #c8d0da', overflow: 'hidden' }}>
            <div style={{ padding: '8px 14px', borderBottom: '1px solid #e8eaed', display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 10 }}>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: '#0a1628', marginBottom: 2 }}>{a.nome}</div>
                <p style={{ fontSize: 12, color: '#6b7280', lineHeight: 1.5, margin: 0 }}>{a.descricao}</p>
              </div>
              <span style={{
                flexShrink: 0,
                background: a.ativo ? '#f0fdf4' : '#f3f4f6',
                color: a.ativo ? '#16a34a' : '#6b7280',
                border: `1px solid ${a.ativo ? '#bbf7d0' : '#e5e7eb'}`,
                borderRadius: 10, padding: '2px 10px', fontSize: 11, fontWeight: 700,
              }}>
                {a.ativo ? '● Ativa' : '○ Inativa'}
              </span>
            </div>

            <div style={{ padding: '8px 14px', background: '#fafafa', display: 'flex', gap: 20, flexWrap: 'wrap' }}>
              <div style={{ minWidth: 160 }}>
                <div style={{ fontSize: 10, fontWeight: 600, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 2 }}>Gatilho</div>
                <div style={{ fontSize: 12, color: '#374151', fontWeight: 500 }}>{a.gatilho}</div>
              </div>
              <div style={{ minWidth: 160 }}>
                <div style={{ fontSize: 10, fontWeight: 600, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 2 }}>Canal</div>
                <div style={{ fontSize: 12, color: '#374151', fontWeight: 500 }}>{a.canal}</div>
              </div>
              <div style={{ flex: 1, minWidth: 180 }}>
                <div style={{ fontSize: 10, fontWeight: 600, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 4 }}>Regras</div>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: 2 }}>
                  {a.detalhes.map((d, i) => (
                    <li key={i} style={{ fontSize: 12, color: '#374151', display: 'flex', gap: 5 }}>
                      <span style={{ color: '#0a1628', fontWeight: 700, flexShrink: 0 }}>→</span> {d}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div style={{ marginTop: 14, background: '#f0f4ff', border: '1px solid #c7d2fe', borderRadius: 4, padding: '10px 14px', fontSize: 12, color: '#3730a3' }}>
        <strong>Novas automações</strong> — Para adicionar automações futuras (ex: aniversário de clientes, follow-up de propostas, alertas de vencimento), entre em contato.
      </div>
    </div>
  );
}
